/* src/app/shared/components/ag-toggle-button/ag-toggle-button.component.scss */
.disabled .slider {
  background-color: #a6a6a6 !important;
}
.disabled .not-selected-option p {
  color: #a6a6a6 !important;
}
.disabled-not-selected .not-selected-option p {
  color: #a6a6a6 !important;
}
.not-selected-option {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.grey-outline {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background-color: #f2f2f2;
  height: 48px;
  overflow: hidden;
}
.option-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  border-radius: 8px;
}
.slider {
  position: absolute;
  width: 120px;
  height: 40px;
  background-color: #222222;
  border-radius: 12px;
  top: 4px;
  left: 0;
  transition: transform 0.2s ease-in-out;
}
.p-medium {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
.mobile-p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-size: 12px;
}
.large-p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-size: 16px;
}
.selected-option p,
.not-selected-option p {
  transition: color 0.2s ease-in-out;
}
.selected-option p {
  color: #ffffff;
}
.not-selected-option p {
  color: #222222;
}
img {
  transition: filter 0.2s ease-in-out;
}
.option-with-image {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=ag-toggle-button.component.css.map */
